import script from "./Franchise.vue?vue&type=script&setup=true&lang=js"
export * from "./Franchise.vue?vue&type=script&setup=true&lang=js"

import "./Franchise.vue?vue&type=style&index=0&id=1327432e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1327432e"]])

export default __exports__